<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Cancel Case</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">

  <app-card-label label="Cancellation Reason">
    <select class="form-select" [(ngModel)]="selectedReason">
      <option *ngFor="let reason of reasons" [value]="reason.id">{{reason.reason}}</option>
    </select>
  </app-card-label>

  <app-card-label label="Details" [hidden]="selectedReason != 1">
    <textarea class="form-control" [(ngModel)]="cancellationReasonOther" maxlength="500" rows="4"></textarea>
  </app-card-label>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-success"
    [disabled]="(selectedReason == null) || (selectedReason == 1 && (cancellationReasonOther == null || cancellationReasonOther.length == 0))"
    (click)="save()">Save</button>
</div>